import type { Option } from '@ksyos/design-system';
import { FormGroup, FormParagraph, FormSection, Select } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import type { IServiceConsumer } from '@frontend/components/interfaces/serviceConsumer';
import type { IServiceProvider } from '@frontend/components/interfaces/serviceProvider';
import { FormattedDate } from '@frontend/components/userDataManagement/FormattedDate';
import { translateKey } from '@frontend/translate';
import { useFrontendSettings } from '@frontend/utils/hooks/useFrontendSettings';

type RightsRequestType = IServiceConsumer | IServiceProvider;

interface IRightRequestSettingsdSettingsProps {
    isAutoCreated: boolean;
    isEditMode: boolean;
    onChange: (key: keyof RightsRequestType, value: boolean) => void;
    setToRequestedRightDateTime: string | Date | null;
}

export function RightRequestSettings(props: IRightRequestSettingsdSettingsProps) {
    const { isAutoCreated, isEditMode, setToRequestedRightDateTime } = props;
    const { frontendSettings } = useFrontendSettings();

    const [selectedOption, setSelectedOption] = useState<Option | null>(null);

    const [rightRequestOptions] = useState<Option[]>(() => [
        { label: translateKey('personalSettings.carePathDetails.automaticallyAssigned'), value: 'true' },
        { label: translateKey('personalSettings.carePathDetails.requestedByPractitioner'), value: 'false' },
    ]);

    useEffect(() => {
        setSelectedOption(rightRequestOptions.find((option) => option.value === String(isAutoCreated))!);
    }, [rightRequestOptions, isAutoCreated]);

    if (!frontendSettings.autoCreatedRightsEnabled) {
        return <></>;
    }

    return (
        <FormSection>
            <FormGroup label={translateKey('personalSettings.carePathDetails.serviceRightObtained')}>
                {isEditMode ? (
                    <Select
                        onChange={async (option: Option | null) => {
                            if (option) {
                                setSelectedOption(option);
                                props.onChange('isAutoCreated', option.value === 'true');
                            }
                        }}
                        options={rightRequestOptions}
                        value={selectedOption}
                    />
                ) : (
                    <FormParagraph>{selectedOption?.label}</FormParagraph>
                )}
            </FormGroup>

            {setToRequestedRightDateTime && (
                <FormGroup label={translateKey('personalSettings.carePathDetails.dateOfRightRequest')}>
                    <FormattedDate value={setToRequestedRightDateTime} />
                </FormGroup>
            )}
        </FormSection>
    );
}
